<template>
  <b-container fluid>
    <!-- confirm modal -->
    <b-modal
      id="confirm-user"
      ref="confirm-user"
      title="You will lose access immediately, do you wish to proceed or cancel?"
      size="lg"
      hide-footer
    >
      <b-form @submit="confirmUserModalSubmit">
        <b-button type="submit" variant="danger" class="mb-2">Yes</b-button>

        <b-button
          variant="success"
          class="mb-2 ml-2"
          @click="$bvModal.hide('confirm-user')"
          >No</b-button
        >
      </b-form>
    </b-modal>

    <div class="payment-container">
      <div class="update-confirmation" v-show="confirmUpdate">
        <h2>
          <span class="update-confirmation-text"
            >Are you sure you want to update your payment method?</span
          >
        </h2>
        <div class="update-btns">
          <div class="update-yes-btn" @click="handleUpdatePayment">
            <span>Yes</span>
          </div>
          <div class="update-no-btn" @click="handleNoButton">
            <span>No</span>
          </div>
        </div>
      </div>
      <div class="cancel-confirmation" v-show="confirmCancel && !trialCancel">
        <div class="cancel-confirmation-title">
          <span>Are you sure you want to cancel?</span>
        </div>
        <div class="cancel-confirmation-text">
          <span>
            By cancelling your
            <i>
              <b>one-time free trial</b>
            </i>
            you will lose all access immediately. By cancelling a paid
            subscription, you will retain access to our services until the next
            invoice date.
          </span>
        </div>
        <div class="cancel-btns">
          <div class="cancel-yes-btn" @click="confirmCancellation">
            <span>Yes</span>
          </div>
          <div class="cancel-no-btn" @click="handleNoButton">
            <span>No</span>
          </div>
        </div>
      </div>

      <!-- Cancel Trial -->
      <div
        class="cancel-confirmation"
        v-if="trialCancel && selectedCancelOption.length == 0"
      >
        <div class="cancel-confirmation-title">
          <span>Why are canceling ?</span>
        </div>
        <div class="cancel-confirmation-text">
          <b-form-group label="Individual radios" v-slot="{ ariaDescribedby }">
            <b-form-radio
              v-model="selectedCancelOption"
              :aria-describedby="ariaDescribedby"
              name="Didn't make money"
              value="Didn't make money"
              >Didn't make money</b-form-radio
            >
            <b-form-radio
              v-model="selectedCancelOption"
              :aria-describedby="ariaDescribedby"
              name="System was too confusing"
              value="System was too confusing"
              >System was too confusing</b-form-radio
            >
            <b-form-radio
              v-model="selectedCancelOption"
              :aria-describedby="ariaDescribedby"
              name="Too expensive"
              value="Too expensive"
              >Too expensive</b-form-radio
            >
            <b-form-radio
              v-model="selectedCancelOption"
              :aria-describedby="ariaDescribedby"
              name="Not for me"
              value="Not for me"
              >Not for me</b-form-radio
            >
          </b-form-group>
        </div>
        <div class="cancel-btns"></div>
      </div>

      <!-- Offer -->
      <div
        class="cancel-confirmation"
        v-if="trialCancel && selectedCancelOption.length > 0"
      >
        <div>
          <h5 id="question">
            We are going to give you a one time offer of 50% off your first
            month and then the subscription will continue at $156 per month.
          </h5>
        </div>
        <div class="cancel-confirmation-text">
          <p>Would you like to claim this limited time offer?</p>
        </div>
        <div class="cancel-btns">
          <div class="cancel-btns">
            <div class="cancel-yes-btn" @click="clamOffer">
              <span>Yes</span>
            </div>
            <div class="cancel-no-btn" @click="confirmCancellation">
              <span>No</span>
            </div>
          </div>
        </div>
      </div>

      <div class="splash-container" v-show="pendingRequest">
        <div class="splash">
          <div class="splash-content" />
        </div>
      </div>

      <div
        class="payment-view"
        v-show="
          !confirmUpdate && !confirmCancel && !pendingRequest && !trialCancel
        "
      >
        <div class="payment-header-wrapper">
          <span>Payment Information</span>
        </div>
        <div class="cc-info-wrapper" v-if="!canceled && !preventTrialLoop">
          <span class="cc-info-text__1"
            >Your current payment method managed via Stripe is a</span
          >
          <span class="cc-info-text__2">{{ ccType }}</span>
          <span class="cc-info-text__3">ending in</span>
          <span class="cc-info-text__4" style="font-weight= 700">{{
            ccLast4
          }}</span>
          <div ref="card"></div>
        </div>
        <div class="btn-container">
          <div class="update-payment">
            <button
              @click="handleUpdateButton"
              :disabled="disableButton"
              v-if="!canceled"
            >
              <span class="update-payment-text">Update Payment</span>
            </button>
          </div>
          <div
            class="cancel-sub"
            @click="handleCancelSubscriptionButton"
            v-if="!canceled"
          >
            <button>
              <span class="cancel-sub-text">Cancel Subscription</span>
            </button>
          </div>
        </div>
        <div class="cc-info-wrapper__2" v-if="canceled && preventTrialLoop">
          <span class="cc-info-text__5">{{ preventTrialContent }}</span>
        </div>
        <div class="prevent-btn-container">
          <div
            class="resub"
            @click="handleResubscribeButton"
            v-if="canceled && preventTrialLoop"
          >
            <button>
              <span class="resub-text">Resubscribe</span>
            </button>
          </div>
          <div
            class="cancel-sub"
            @click="handleCancelSubscriptionButton"
            v-if="canceled && preventTrialLoop"
          >
            <button>
              <span class="cancel-sub-text">Cancel Subscription</span>
            </button>
          </div>
        </div>
        <div class="cc-info-wrapper__3" v-if="canceled && !preventTrialLoop">
          <span class="cc-info-text__6">{{ canceledContent }}</span>
        </div>
        <div class="cancel-btn-container">
          <div
            class="resub"
            @click="handleResubscribeButton"
            v-if="canceled && !preventTrialLoop"
          >
            <button>
              <span class="resub-text">Resubscribe</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";

import db from "../../database/index";
const collection = db.collection("users");

let card;
let stripe;

export default {
  name: "Payment",
  props: {
    user: {
      type: Object,
    },
    discord: {
      type: Object,
    },
  },
  data() {
    return {
      selectedCancelOption: "",
      stripeToken: "",
      confirmUpdate: false,
      confirmCancel: false,
      trialCancel: false,
      isTrial: false,
      pendingRequest: false,
      canceled: false,
      disableButton: true,
      ccLast4: this.user.ccLast4,
      ccType: this.user.ccType,
      preventTrialLoop: this.user.preventTrialLoop,
      preventTrialContent: `WARNING: Duplicate trial detected, trials are limited to (1) per user. To get immediate access, cancel your subscription and resubscribe using the buttons below. Your current subscription WILL NOT automatically cancel. If you do not cancel, you will be charged at the end of your trial period.`,
      canceledContent: `Oh no, it looks like you don't have an active subscription! If you are a previous member and would like to resubscribe, click the button below. Please contact an admin if you believe this is an error.`,
    };
  },
  async mounted() {
    stripe = await loadStripe("pk_live_HcfQGKUjA8INdqh9snEI0rig001nvq0a4I");
    const elements = stripe.elements();

    if (this.user.type === "trial" && this.user.preventTrialLoop === false) {
      this.isTrial = true;
    }

    if (this.user.status === "canceled") {
      this.canceled = true;
    }

    if (this.user.preventTrialLoop === true) {
      this.preventTrialLoop = true;
    }

    card = elements.create("card");
    card.mount(this.$refs.card);

    card.on("change", (e) => {
      if (e.complete) {
        this.disableButton = false;
      } else {
        this.disableButton = true;
      }
    });
  },
  methods: {
    async clamOffer() {
      const { subscriptionId } = this.user;

      const cancelOptions = {
        url: "https://us-central1-market-moves.cloudfunctions.net/app/api/stripe/update-subscription/",
        method: "POST",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
        data: {
          subscription_id: subscriptionId,
        },
      };

      // Send a post request to Stripe's API to cancel subscription at period end
      await axios(cancelOptions)
        .then(() => {
          this.trialCancel = false;
          alert("Subscription successfully updated.");
        })
        .catch(() =>
          alert(
            "Unexpeceted error occured."
          )
        );
    },
    async handleUpdatePayment() {
      this.confirmUpdate = false;
      this.pendingRequest = true;

      // Create stripe payment token from input fields
      await stripe
        .createToken(card)
        .then((res) => {
          this.stripeToken = res.token.id;
        })
        .catch((err) => console.error(err));

      const { customerId, subscriptionId } = this.user;

      // Checkout session request options
      const sessionOptions = {
        url: "https://us-central1-market-moves.cloudfunctions.net/app/api/stripe/update",
        method: "POST",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
        data: {
          customer_id: customerId,
          subscription_id: subscriptionId,
          stripeToken: this.stripeToken,
        },
      };

      // Request update via Stripe API then update firestore
      await axios(sessionOptions)
        .then(async (res) => {
          await this.updateUser(res.data);
        })
        .catch((err) => console.error(err));

      // Fetch updated doc from firestore
      await this.fetchUserData();

      // Clear input fields
      card.clear();
      this.pendingRequest = false;
    },
    async confirmCancellation() {
      if (this.user && this.user["type"] == "trial") {
        this.$refs["confirm-user"].show();
        return;
      }

      this.callUserPaymentCancelApi();
    },
    async confirmUserModalSubmit(e) {
      e.preventDefault();

      this.callUserPaymentCancelApi("modalClose");
    },
    async callUserPaymentCancelApi(value = null) {
      this.confirmCancel = false;
      this.pendingRequest = true;

      const { subscriptionId } = this.user;

      const cancelOptions = {
        url: `https://us-central1-market-moves.cloudfunctions.net/app/api/stripe/cancel`,
        method: "POST",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
        data: {
          subscription_id: subscriptionId,
        },
      };

      // Send a post request to Stripe's API to cancel subscription at period end
      await axios(cancelOptions)
        .then(() => alert("Subscription successfully canceled."))
        .catch(() =>
          alert(
            "Unexpeceted error occured. Subscription has already been canceled."
          )
        );

      this.pendingRequest = false;

      if (value == "modalClose") {
        this.$refs["confirm-user"].hide();
      }
    },
    handleUpdateButton() {
      this.confirmUpdate = true;
    },
    handleCancelSubscriptionButton() {
      if (this.isTrial) {
        this.trialCancel = true;
      } else {
        this.confirmCancel = true;
      }
      console.log("confirmCancel ", this.trialCancel);
    },
    handleNoButton() {
      this.confirmUpdate = false;
      this.confirmCancel = false;
    },
    async updateUser(data) {
      this.ccLast4 = data.card.last4;
      this.ccType = this.capitalizeFirstLetter(data.card.brand);

      return await collection
        .where("discordId", "==", this.discord.id)
        .get()
        .then((snap) =>
          snap.forEach(async (doc) => {
            await collection.doc(doc.id).update({
              ccLast4: data.card.last4,
              ccMonth: data.card.exp_month,
              ccYear: data.card.exp_year,
              ccType: this.capitalizeFirstLetter(data.card.brand),
            });
          })
        );
    },
    async fetchUserData() {
      return await collection
        .where("discordId", "==", this.discord.id)
        .get()
        .then((snap) =>
          snap.forEach((doc) => {
            this.user = doc.data();
          })
        );
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    handleResubscribeButton() {
      this.$router.push({ path: "/signup" });
    },
  },
};
</script>

<style scoped>
.payment-container {
  height: 240px;
  width: 400px;
  background-color: #36393f;
  color: #f8f8f8;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 20px;
  box-shadow: 1px 1px 0px #282b2f, 2px 2px 0px #2f3033, 3px 3px 0px #282b2f,
    4px 4px 0px #2f3033, 5px 5px 0px #282b2f, 6px 6px 0px #2f3033;
}

.payment-header-wrapper {
  padding-top: 20px;
  font-weight: 800;
  font-size: 1.17em;
  text-transform: uppercase;
}

.cc-info-wrapper {
  margin-top: 10px;
  margin-bottom: 30px;
  padding-right: 15px;
  padding-left: 15px;
  font-size: 14px;
}

.cc-info-text__2 {
  font-weight: bolder;
}

.cc-info-text__4 {
  font-weight: 900;
}

.btn-container {
  display: flex;
  justify-content: space-evenly;
  /* margin-top: 12px; */
}

.prevent-btn-container {
  display: flex;
  justify-content: space-evenly;
  margin-top: 12px;
}

.cancel-btn-container {
  display: flex;
  justify-content: center;
  margin-top: 12px;
}

.update-payment button {
  background-color: #7289da;
  border: #7289da;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 13px;
  padding: 6px 22px;
  text-decoration: none;
  width: 175px;
}

.update-payment button:hover {
  background-color: #818fc0;
}

.update-payment button:active {
  position: relative;
  top: 1px;
}

.update-payment button:focus {
  outline: 0;
}

.cancel-sub button {
  background-color: #eb675e;
  border: #eb675e;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 13px;
  padding: 6px 22px;
  text-decoration: none;
  text-shadow: 0px 1px 0px #b23e35;
  width: 175px;
  height: 28px;
}

.cancel-sub button:hover {
  background-color: #e98f88;
  border-color: #e98f88;
}

.cancel-sub button:active {
  position: relative;
  top: 1px;
}

.cancel-sub button:focus {
  outline: 0;
}

.StripeElement {
  margin: 0 auto;
  margin-top: 30px;
  width: 370px;
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
  position: relative;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.update-confirmation {
  padding-top: 30px;
}

.update-btns {
  display: flex;
  justify-content: space-evenly;
}

.update-yes-btn {
  background: #eb675e;
  width: 70px;
  height: 28px;
  border-radius: 12px;
  line-height: 28px;
  margin: 0 auto;
  font-size: 14px;
}

.update-yes-btn:hover {
  background: #e98f88;
  border: #e98f88;
}

.update-no-btn {
  background: #7289da;
  width: 70px;
  height: 28px;
  border-radius: 12px;
  line-height: 28px;
  margin: 0 auto;
  font-size: 14px;
}

.update-no-btn:hover {
  background: #818fc0;
  border: #818fc0;
}

.cancel-confirmation {
  padding-top: 30px;
}

.cancel-confirmation-title {
  padding-left: 25px;
  padding-right: 25px;
  font-size: 1.17em;
  font-weight: 800;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 10px;
}

.cancel-confirmation-text {
  margin-top: 10px;
  margin-bottom: 15px;
  padding-left: 25px;
  padding-right: 25px;
  font-size: 14px;
  text-align: justify;
}

.cancel-btns {
  display: flex;
  justify-content: space-evenly;
}

.cancel-yes-btn {
  background: #eb675e;
  width: 70px;
  height: 28px;
  border-radius: 12px;
  line-height: 28px;
  margin: 0 auto;
  font-size: 14px;
}

.cancel-yes-btn:hover {
  background: #e98f88;
  border: #e98f88;
}

.cancel-no-btn {
  background: #7289da;
  width: 70px;
  height: 28px;
  border-radius: 12px;
  line-height: 28px;
  margin: 0 auto;
  font-size: 14px;
}

.cancel-no-btn:hover {
  background: #818fc0;
  border: #818fc0;
}

.splash {
  margin: 0 auto;
  padding-top: 76px;
}

#question {
  padding: 10px;
}

.splash-content {
  width: 88px;
  height: 88px;
  margin: 0 auto;
  border: 3px solid #7289da;
  border: 3px solid transparent;
  border-top-color: #7289da;
  border-bottom-color: #7289da;
  border-radius: 50%;
  -webkit-animation: loader 2s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
  animation: loader 2s linear infinite;
}

@keyframes loader {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.cc-info-wrapper__2 {
  margin-top: 20px;
  margin-bottom: 25px;
  padding-right: 25px;
  padding-left: 25px;
  font-size: 14px;
  text-align: justify;
}

.cc-info-wrapper__3 {
  margin-top: 30px;
  margin-bottom: 35px;
  padding-right: 25px;
  padding-left: 25px;
  font-size: 14px;
  text-align: justify;
}

.resub button {
  background-color: #7289da;
  border: #7289da;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 13px;
  padding: 6px 22px;
  text-decoration: none;
  width: 175px;
}

.resub button:hover {
  background-color: #818fc0;
}

.resub button:focus {
  outline: 0;
}
</style>